module.exports = __webpack_public_path__ + "img/label-8SIMPLE.6aba3613.jpeg";